export enum EDocumentType {
    Result = 1,
    Plan = 2,
    GenerateReport = 3,
    OverrideReport = 4
}